(() => {
  'use strict';
  if (window.__thesoongLocaleCurrencyLoaded) return;
  window.__thesoongLocaleCurrencyLoaded = true;

  const rates = Object.freeze({ USD: 1, CNY: 6.684036, JPY: 158.39919, KRW: 1343.930997 });
  const lang = String(document.documentElement.lang || '').toLowerCase();
  const path = location.pathname.toLowerCase();
  let config = { code: 'USD', symbol: '$', locale: 'en-US', rate: rates.USD, digits: 2 };
  if (lang.startsWith('zh') || /^\/(zh-hans|zh-cn|zh)(\/|$)/.test(path)) {
    config = { code: 'CNY', symbol: '¥', locale: 'zh-CN', rate: rates.CNY, digits: 0 };
  } else if (lang.startsWith('ja') || /^\/ja(\/|$)/.test(path)) {
    config = { code: 'JPY', symbol: '¥', locale: 'ja-JP', rate: rates.JPY, digits: 0 };
  } else if (lang.startsWith('ko') || /^\/ko(\/|$)/.test(path)) {
    config = { code: 'KRW', symbol: '₩', locale: 'ko-KR', rate: rates.KRW, digits: 0 };
  }

  document.documentElement.dataset.thesoongDisplayCurrency = config.code;
  document.documentElement.dataset.thesoongUsdCny = String(rates.CNY);
  document.documentElement.dataset.thesoongUsdJpy = String(rates.JPY);
  document.documentElement.dataset.thesoongUsdKrw = String(rates.KRW);
  if (config.code === 'USD') return;

  const formatter = new Intl.NumberFormat(config.locale, {
    minimumFractionDigits: config.digits,
    maximumFractionDigits: config.digits,
  });
  const usdPattern = /(?:USD\s*)?\$\s*([0-9][0-9,]*(?:\.[0-9]{1,2})?)(?:\s*USD)?/g;
  const selector = 'bdi, .price, [class*="price" i], [class*="subtotal" i], [class*="total" i], [data-testid*="price" i]';

  const convertText = (value) => value.replace(usdPattern, (_full, amount) => {
    const usd = Number(String(amount).replace(/,/g, ''));
    if (!Number.isFinite(usd)) return _full;
    return `${config.symbol}${formatter.format(usd * config.rate)}`;
  });

  const convertNode = (node) => {
    if (!node || node.nodeType !== Node.TEXT_NODE || !node.nodeValue || !node.nodeValue.includes('$')) return;
    const converted = convertText(node.nodeValue);
    if (converted !== node.nodeValue) node.nodeValue = converted;
  };

  const convertRoot = (root) => {
    if (!root) return;
    if (root.nodeType === Node.TEXT_NODE) { convertNode(root); return; }
    if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_FRAGMENT_NODE && root.nodeType !== Node.DOCUMENT_NODE) return;
    const elements = [];
    if (root.nodeType === Node.ELEMENT_NODE && root.matches(selector)) elements.push(root);
    if (root.querySelectorAll) elements.push(...root.querySelectorAll(selector));
    for (const element of elements) {
      const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
      let text;
      while ((text = walker.nextNode())) convertNode(text);
    }
  };

  const updateCurrencyBadge = (root = document) => {
    const badges = root.querySelectorAll?.('[data-testid="localization-currency-code"]') || [];
    for (const badge of badges) {
      if (badge.textContent?.trim() !== config.code) badge.textContent = config.code;
    }
  };

  const run = () => { convertRoot(document); updateCurrencyBadge(document); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();

  const pendingRoots = new Set();
  let updateQueued = false;
  const queueUpdate = (root) => {
    if (root) pendingRoots.add(root);
    if (updateQueued) return;
    updateQueued = true;
    requestAnimationFrame(() => {
      updateQueued = false;
      for (const pendingRoot of pendingRoots) convertRoot(pendingRoot);
      pendingRoots.clear();
      updateCurrencyBadge(document);
    });
  };

  const observer = new MutationObserver((records) => {
    for (const record of records) {
      if (record.type === 'characterData' && record.target.nodeValue?.includes('$')) queueUpdate(record.target);
      for (const node of record.addedNodes) queueUpdate(node);
    }
  });
  observer.observe(document.documentElement, { subtree: true, childList: true, characterData: true });
})();